import { Link } from '@reach/router';
import styled, { css } from '../theme/styled-components';
import { GridColumns } from '../utils/GridColumns';

interface IBox {
  backgroundColor?: string;
  mode?: boolean;
}

export const Box = styled.div<IBox>`
  background-color: ${props =>
    props.backgroundColor
      ? props.backgroundColor
      : props.theme.colors.primary.base};
  color: ${props =>
    props.mode
      ? props.theme.colors.typography.light.base
      : props.theme.colors.typography.dark.base};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 1px solid ${props => props.theme.colors.border.light.base};

  padding-top: ${props => props.theme.spacings.base};
  padding-bottom: ${props => props.theme.spacings.base};
  margin-bottom: ${props => props.theme.spacings.base};
  margin-left: -${props => props.theme.spacings.medium};
  margin-right: -${props => props.theme.spacings.medium};

  ${media => media.theme.media.greaterThan('medium')`
    width: ${props => props.theme.boxSizes.medium.width};
    height: ${props => props.theme.boxSizes.medium.height};
    margin: 0;
    justify-content: flex-start;
    padding-top: ${props => props.theme.spacings.base};
    margin-left: 0;
    margin-right: 0;
    align-items: flex-start;
    padding-left: ${props => props.theme.spacings.base};
    padding-right: ${props => props.theme.spacings.base};
  `}
`;

export const FrontPageBox = styled(Box)`
  ${media => media.theme.media.greaterThan('medium')`
    align-items: center;
    padding-left: 0;
  `}

  ${media => media.theme.media.greaterThan('large')`
    width: ${props => props.theme.boxSizes.large.width};
    height: ${props => props.theme.boxSizes.large.height};
    margin-bottom: ${props => props.theme.spacings.base};
    padding-top: ${props => props.theme.spacings.medium};
  `};
`;

export const BoxMobile = styled(Box)`
  ${media => media.theme.media.greaterThan('medium')`
    display: none;
  `}
`;

export const BoxDesktop = styled(Box)`
  color: ${props => props.theme.colors.typography.light.base};
  ${media => media.theme.media.lessThan('downMedium')`
    display: none;
  `}
`;

const BaseBoxes = css<IBox>`
  flex-wrap: wrap;
  display: none;
  padding: ${props => props.theme.spacings.base};
  background-color: ${props => props.backgroundColor};
  border: 1px solid ${props => props.theme.colors.border.dark.base};
  color: ${props =>
    props.mode
      ? props.theme.colors.typography.light.base
      : props.theme.colors.typography.dark.base};

  ${media => media.theme.media.greaterThan('medium')`
    display: flex;
    align-items: flex-start;
    height: 10rem;
    margin-bottom: 1%;
  `};

  ${media => media.theme.media.between('medium', 'downLarge')`
    ${() => GridColumns(4)}
    max-height: 15vw;
    min-height: 21vw;
  `}

  ${media => media.theme.media.between('large', 'downHuge')`
    ${() => GridColumns(3)}
    max-height: 15vw;
    min-height: 15vw;
  `}

  ${media => media.theme.media.greaterThan('huge')`
    ${() => GridColumns(4)}
    max-height: 12vw;
  `}
`;

export const Boxes = styled.div`
  ${BaseBoxes}
`;

export const LinkBoxes = styled(Link)`
  ${BaseBoxes}

  &:hover,
  &:focus {
    filter: brightness(90%);
    text-decoration: none;
    color: ${props =>
      props.mode
        ? props.theme.colors.typography.light.base
        : props.theme.colors.typography.dark.base};
  }
`;

export const BoxTitle = styled.h2`
  font-size: ${props => props.theme.typography.title.fontSize};
`;

export const ServiceBoxTitle = styled.h2<{ mode?: boolean }>`
  font-size: ${props => props.theme.typography.title.fontSize};
  padding-bottom: 0;
  margin-bottom: 0;

  color: ${props =>
    props.mode === undefined || props.mode === true
      ? props.theme.colors.typography.light.base
      : props.theme.colors.typography.dark.base};
`;
